

import React, { memo } from 'react';

import cx from 'classnames';
import {
  BUTTON,
  BUTTON_CENTER,
  BUTTON_CONTENT,
  BUTTON_CONTAINER,
  BUTTON_CONTAINER_DISABLED,
  BUTTON_DISABLED } from
'../styles/radioButton';
import Text from '../../Text';
import Icon from '../../Icon';
import onEnterPressed from '../../../common/utils/onEnterPressed';










function RadioButton(
{ selected, onChange, children, disabled, darkMode, prefixIcon })
{
  const onChangeFunction = disabled ? void 0 : onChange;
  return (
    <div
      className={cx(
        BUTTON_CONTAINER({ selected, darkMode, disabled }),
        'radio-button',
        {
          'radio-button--selected': selected,
          [BUTTON_CONTAINER_DISABLED]: disabled,
          'radio-button--disabled': disabled
        }
      )}
      onKeyDown={onEnterPressed({ onClick: onChangeFunction })}
      onClick={onChangeFunction}
      tabIndex={0}
      role="button">

      <div className={cx(
        BUTTON({ selected, darkMode, disabled }), 'radio-button__button',
        {
          [BUTTON_DISABLED]: disabled,
          'radio-button__button--disabled': disabled
        }
      )}>

        {
        selected ?
        <div className={cx(BUTTON_CENTER({ disabled }), 'radio-button__button__center')} /> :
        null}

      </div>
      <div className={cx(BUTTON_CONTENT, 'radio-button__button__content')}>
        {prefixIcon && <Icon size={20} color="denim" name={prefixIcon} />}
        {typeof children === 'string' ? <Text noMargin>{children}</Text> : children}
      </div>
    </div>);

}

export default memo(RadioButton);